import { jwtDecode } from "jwt-decode";

export const setAuthTokens = (accessToken, refreshToken) => {
    const AT = { value: accessToken, exp: jwtDecode(accessToken).exp };
    localStorage.setItem("access_token", JSON.stringify(AT))

    if (refreshToken) {
        const RT = { value: refreshToken, exp: jwtDecode(refreshToken).exp };
        localStorage.setItem("refresh_token", JSON.stringify(RT))
    }
};

export const setUserData = (userData) => {
    localStorage.setItem("user_data", JSON.stringify(userData));
}

export const removeLocalData = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_data");
}


export const getAccessToken = () => {
    return JSON.parse(localStorage.getItem("access_token"))
}

export const getUserData = () => {
    return JSON.parse(localStorage.getItem("user_data"))
}

export const getRefreshToken = () => {
    return JSON.parse(localStorage.getItem("refresh_token"))
}


export const checkAccessToken = () => {
    return localStorage.getItem("access_token") !== null
}

export const checkUserData = () => {
    return localStorage.getItem("user_data") !== null
}

export const checkRefreshToken = () => {
    return localStorage.getItem("refresh_token") !== null
}

export const isAuthenticated = () => {
    return checkRefreshToken() && checkUserData();
}